import { Component, inject } from '@angular/core';
import { LoaderserviceService } from '../services/loaderservice.service';
import { Subject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [AsyncPipe,
        LottieComponent
    ]
})
export class LoaderComponent {
  private loader = inject(LoaderserviceService);

  isLoading: Subject<boolean>;
  showGlobalLoader: Subject<boolean>;
  constructor() {
    this.isLoading = this.loader.isLoading;
    this.showGlobalLoader = this.loader.showGlobalHeader;
  }


  loaderAnimation: AnimationOptions =
  {
      path: 'assets/lottie/loader-rosseta.json',
      loop: true,
  }

}
